import { Box, Card, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Content from "../Components/Content";
import FilterButtonComp from "../Components/FilterButtonComp";
import RevenueCards from "../CenterAdminDashboard/NewRevenueCards";
import DisplayCurrentDateTime from "../Components/DisplayCurrentDateTime";
import UpcommingEvents from "../Components/UpcommingEvents";
import NewCardcomp from "../../../components/card/NewCardcomp";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import MonthlyRevenuPichart from "../CenterAdminDashboard/MonthlyRevenuPichart";
import { useGetTokenOrLogout } from "../../../utils/token";
import AdminRevenueAndEnrolData from "./AdminRevenueAndEnrolData";
import CustomPopup from "../../../components/CustomPopup";

import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import EnrollDetails from "../popupComponent/EnrollDetails";
import MoreCardDetails from "../popupComponent/MoreCardDetails";
import { useNavigate } from "react-router-dom";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AdminNewDashBoardUi() {
  const userId = localStorage.getItem("userId");
   const countryId  =localStorage.getItem("employeeCountry")
  const getTokenOrLogout = useGetTokenOrLogout();
const navigate=useNavigate()
  const [selectedFilter, setSelectedFilter] = useState("currentmonth");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [cardRevenueData, setCardRevenueData] = useState([]);
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [upcommigevent, setUpcommingEvent] = useState([]);
  const [upcommingLoading, setUpcommingLoding] = useState(false);
  const [chosenDate, setChosenDate] = useState(new Date());
  const [isPieChartLoading, setIsPieChartLoading] = useState(false);
  const [pieChartData, setPieChartData] = useState({});
  const [centerRevenueData, setCenterRevenueData] = useState([]);
  const [isCenterLoading, setIsCenterLoading] = useState(false);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleClickFilter = (criteria, cardFilter) => {
    setSelectedFilter(criteria);

    if (criteria !== "custom") {
      handleApplyRevenuFilter(criteria, null, null);

      setFromDate(null);
      setToDate(null);
    }
    if (criteria === "custom" && fromDate !== null && toDate !== null) {
      handleApplyRevenuFilter(criteria, fromDate, toDate);
    }
  };

  // Fetch Upcomming Event
  useEffect(() => {
    setUpcommingLoding(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          setUpcommingEvent(data);
          setUpcommingLoding(false);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDateChange = (date) => {
    setChosenDate(date);
  };

  // Fetch Card Data
  const handleApplyRevenuFilter = async (criteria, fromDate, toDate) => {
    setRevenueLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),

      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}admindashboard/chip-data`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        setCardRevenueData(result);

        setRevenueLoading(false);
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
     
        navigate("/page500");
      }
    } catch (error) {
   
      navigate("/page500");
    }
  };

  // render first time data
  useEffect(() => {
    if (selectedFilter !== "custom") {
      handleApplyRevenuFilter(selectedFilter);
    }
  }, []);

  // PiechartData
  const getPieChartData = async(date) => {
    setIsPieChartLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: userId,
      date: date,
    };

   

      try {
         const response = await fetch(
        `${API_ENDPOINT}admindashboard/donut-chart`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      if (response.ok){
        const data =await response.json()
         setPieChartData(data);
        setIsPieChartLoading(false);
      }
      else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/login");
      } else {
        setIsCenterLoading(false);
        navigate("/page500");
      }
    } catch (error) {
      setIsCenterLoading(false);
      navigate("/page500");
    }

      }
  

  useEffect(() => {
    getPieChartData(chosenDate);
  }, [chosenDate]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedFilter,
      to_date: toDate,
      from_date: fromDate,
      filter_type: cardFilter,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}admindashboard/fetch-chip-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar("Bad Request", "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");
        setDetailsLoading(false);
      } 
      else if (response.status === 405) {
        showSnackbar("Branch not found for this admin", "error");
        setDetailsLoading(false);
      }else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Grid container spacing={3}>
        {/* Left Side */}
        <Grid item xs={12} lg={9} sm={12} md={9}>
          <Grid container spacing={2}>
            {/* content */}
            <Grid item xs={12}>
              <Content />
            </Grid>

            {/* Filter Button */}
            <Grid item xs={12} sm={12} mt={2}>
              <FilterButtonComp
                selectedFilter={selectedFilter}
                handleClickFilter={handleClickFilter}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />
            </Grid>

            {/* Revenue Cards */}

            <Grid item xs={12} container spacing={1} gap={1}>
              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#D5F6E1"
                  title="Total Revenue"
                  iconSrc="/Group 1000002878.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      cardRevenueData?.total_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Total Revenue", "total_revenue")
                  }
                  countryId={parseInt(countryId)}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#E7F3FF"
                  title="Collected Revenue"
                  iconSrc="/Group 1000002854.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      cardRevenueData?.collected_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo(
                      "Collected Revenue",
                      "collected_revenue"
                    )
                  }
                  countryId={parseInt(countryId)}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFEDFB"
                  title="Pending Revenue"
                  iconSrc="/Group 1000002879.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      cardRevenueData?.pending_revenue
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Pending Revenue", "pending_revenue")
                  }
       countryId={parseInt(countryId)}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFF6E2"
                  title="STM Enrolments"
                  iconSrc="/Group 1000002880.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      cardRevenueData?.new_enrollment
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("New Enrollments", "new_enrolment")
                  }
                />
              </Grid>
               <Grid item xs={12} sm={3.7} lg={2.3}>
                <RevenueCards
                  backGround="#FFF6E2"
                  title="SAP Enrolments"
                  iconSrc="/Group 1000002880.png"
                  value={
                    revenueLoading ? (
                      <CircularProgress />
                    ) : (
                      cardRevenueData?.sap_new_enrollment
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("New Enrollments", "sap_new_enrolment")
                  }
                />
              </Grid>
            </Grid>

            {/* Month Wise Data */}
            <Grid item xs={12}>
              <NewCardcomp height="430px">
                <AdminRevenueAndEnrolData
                  centerRevenueData={centerRevenueData}
                  isCenterLoading={isCenterLoading}
                         countryId={parseInt(countryId)}
                />
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>

        {/* Right Part */}
        <Grid item xs={12} lg={3} sm={12} md={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DisplayCurrentDateTime />
            </Grid>
            <Grid item xs={12}>
              <UpcommingEvents
                data={upcommigevent}
                loading={upcommingLoading}
              />
            </Grid>

            <Grid item xs={12}>
              <NewCardcomp height="285px">
                <LeadCalandar onDateChange={handleDateChange} />
                {isPieChartLoading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    mt={2}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <MonthlyRevenuPichart
                    loading={isPieChartLoading}
                    pieChartData={pieChartData}
                        countryName={parseInt(countryId)}
                  />
                )}
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          (selectedcardFilter === "new_enrolment" || selectedcardFilter === "sap_new_enrolment") ? (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              selectedFilter={selectedFilter}
              SelectedCardData={SelectedCardData}
              fromDate={fromDate}
              toDate={toDate}
            />
          ) : (
            <MoreCardDetails
              onClose={handleCloseDetailPopup}
              selectedFilter={selectedFilter}
              SelectedCardData={SelectedCardData}
              selectedCardName={selectedCardName}
              selectedCountFilter={selectedcardFilter}
              fromDate={fromDate}
              toDate={toDate}
              countryId={parseInt(countryId)}
            />
          )
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
